export const OPEN_TECH_SUPPORT_CHAT_EVENT = "cargorun:open-tech-support-chat";
